import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=46a7baba&"
import script from "./ActivityDetails.vue?vue&type=script&lang=js&"
export * from "./ActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports